// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T4vI","top":"styles_top__1AU0E","left":"styles_left__15_H_","description":"styles_description__3edG0"};